export const getInitials = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => {
  const first = firstName?.[0] || '';
  const last = lastName?.[0] || '';

  return (first + last).toUpperCase() || 'U';
};

export const getInitialsFromName = (
  name: string | null | undefined
): string => {
  if (!name) return '';

  const words = name.trim().split(/\s+/);
  const first = words[0]?.[0] || '';
  const second = words[1]?.[0] || '';

  return (first + second).toUpperCase();
};

export interface TruncatedDisplay {
  displayText: string;
  isTruncated: boolean;
}

export const getTruncatedDisplay = (
  value: string,
  maxLength: number
): TruncatedDisplay => {
  if (value.length <= maxLength) {
    return { displayText: value, isTruncated: false };
  }

  return {
    displayText: `${value.slice(0, maxLength)}...`,
    isTruncated: true,
  };
};
